module.exports = __webpack_public_path__ + "static/media/line-md_emoji-smile.05b3ad80.svg";